import TakeExpertAdvice from "./TakeExpertAdvice";
import BusinessAdvisory from "./BusinessAdvisory";
import CertifiedFinancial from "./CertifiedFinancial";
import CharteredAccountant from "./CharteredAccountant";
import CompanySecretory from "./CompanySecretory";
import CostAccountant from "./CostAccountant";
import CyberCrime from "./CyberCrime";
import LegalAdvisor from "./LegalAdvisor";

export default TakeExpertAdvice;
export {
  BusinessAdvisory,
  CertifiedFinancial,
  CharteredAccountant,
  CompanySecretory,
  CostAccountant,
  CyberCrime,
  LegalAdvisor,
};
